import { configApi } from 'api';
import { UserPermissionsResponse } from 'pco-product-service-internal-consumer';

export const getUserPermissions = async (): Promise<UserPermissionsResponse> => {
  return await configApi.getUserPermissions();
};
